import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { CheckCircle, XCircle, Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

const EmailVerification = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading"); // loading, success, error
  const [message, setMessage] = useState("");
  
  const token = searchParams.get("token");
  
  useEffect(() => {
    const verifyEmail = async () => {
      if (!token) {
        setStatus("error");
        setMessage("Lien de vérification invalide");
        return;
      }
      
      try {
        const response = await axios.get(`${API}/customer/auth/verify?token=${token}`, {
          withCredentials: true
        });
        setStatus("success");
        setMessage(response.data.message);
        
        // Redirect to dashboard after 2 seconds
        setTimeout(() => {
          navigate("/mon-compte");
        }, 2000);
      } catch (error) {
        setStatus("error");
        setMessage(error.response?.data?.detail || "Erreur lors de la vérification");
      }
    };
    
    verifyEmail();
  }, [token, navigate]);
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-white to-purple-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardContent className="p-8 text-center">
          {status === "loading" && (
            <>
              <Loader2 className="w-16 h-16 text-primary mx-auto mb-4 animate-spin" />
              <h2 className="text-xl font-bold text-slate-800 mb-2">Vérification en cours...</h2>
              <p className="text-slate-500">Patiente quelques secondes</p>
            </>
          )}
          
          {status === "success" && (
            <>
              <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h2 className="text-xl font-bold text-slate-800 mb-2">Email vérifié !</h2>
              <p className="text-slate-500 mb-4">{message}</p>
              <p className="text-sm text-slate-400">Redirection vers ton espace client...</p>
            </>
          )}
          
          {status === "error" && (
            <>
              <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
              <h2 className="text-xl font-bold text-slate-800 mb-2">Erreur</h2>
              <p className="text-slate-500 mb-4">{message}</p>
              <Button onClick={() => navigate("/connexion")} className="bg-primary">
                Retour à la connexion
              </Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default EmailVerification;
